/**
 * HeaderSlim component.
 * @module components/ArpavTheme/Header/HeaderSlim
 */

import {
  ArLogin,
  LanguageSelector,
  ParentSiteMenu,
  TertiaryMenu,
} from '@arpav/components/ArpavTheme';

import { useSelector } from 'react-redux';

const HeaderSlimRightZone = () => {
  const subsite = useSelector(state => state.subsite?.data);
  return (
    <>
      <ParentSiteMenu />
      {!subsite && <TertiaryMenu />}
      <LanguageSelector />
      <ArLogin />
    </>
  );
};

export default HeaderSlimRightZone;
